import moment from "moment-timezone";
import { uniqBy } from "lodash";

export const createProjectMeta = (selectedProject: any) => {
  if (!selectedProject) return [];

  return [
    {
      label: "Order Date",
      value: moment(new Date(selectedProject?.order?.created_at)).format(
        "MM/DD/YY HH:mm"
      ),
    },
    {
      label: "Pages",
      value:
        selectedProject?.order?.translation_type === "standard"
          ? null
          : Number(selectedProject?.order?.page_count || 0),
    },
    {
      label: "Words",
      value:
        selectedProject?.order?.translation_type === "certified"
          ? null
          : Number(selectedProject?.order?.words_count || 0),
    },
    {
      label: "Type",
      value: selectedProject?.order?.translation_type || "Undefined",
    },
    {
      label: "Notarized",
      value:
        selectedProject?.order?.translation_type === "certified"
          ? selectedProject?.order?.include_notarization === "1"
            ? "Yes"
            : "No"
          : null,
    },
    {
      label: "Two-Day Shipping Delivery",
      value:
        selectedProject?.order?.translation_type === "certified"
          ? selectedProject?.order?.include_2_day_shipping === "1" ||
            selectedProject?.order?.include_mail_hard_copy === "1"
            ? "Yes"
            : "No"
          : null,
    },
    {
      label: "Expedite Translation",
      value:
        selectedProject?.order?.include_expedited_turnaround === "1"
          ? "Yes"
          : "No",
    },
    {
      label: "Desktop Publishing",
      value:
        selectedProject?.order?.translation_type === "standard"
          ? selectedProject?.order?.include_desktop_publishing === "1"
            ? "Yes"
            : "No"
          : null,
    },
    {
      label: "Proofreading",
      value:
        selectedProject?.order?.translation_type === "standard"
          ? selectedProject?.order?.include_proofreading === "1"
            ? "Yes"
            : "No"
          : null,
    },
    {
      label: "Price",
      value: `$${selectedProject?.order?.order_total || 0}`,
    },
    {
      label: "Address",
      value:
        selectedProject?.order?.translation_type === "certified"
          ? selectedProject?.order?.address_fields?.length > 0
            ? selectedProject?.order?.address_fields
            : null
          : null,
    },
  ];
};

export const getCustomerInfo = (selectedProject: any) => {
  if (selectedProject) {
    const { order } = selectedProject;
    if (order) {
      return {
        name: `${order.first_name} ${order.last_name}`,
        email: order.email,
        userId: order.user_id,
      };
    }
  }

  return {
    name: "",
    email: "",
    userId: undefined,
  };
};

export const getProjectManagers = (selectedProject: any) => {
  if (selectedProject) {
    return uniqBy(selectedProject.projectManager, "user_id")?.map(
      (it: any) => {
        return `${it.first_name} ${it.last_name}`;
      }
    );
  }
  return [];
};

export const getDocuments = (
  selectedProject: any,
  orderTargetLanguages: string[],
  selectedTargetLanguages: string[]
) => {
  if (selectedProject) {
    let results = selectedProject?.documents || [];
    const translated_from =
      selectedProject?.order?.translated_from || "English";
    const translated_to = orderTargetLanguages.join(",");
    const effectiveTarget =
      selectedTargetLanguages.length > 0
        ? selectedTargetLanguages.join(",")
        : translated_to;
    return results.map((it: any) => {
      return {
        ...it,
        hasChanged: false,
        source_lang: translated_from,
        target_lang: effectiveTarget,
        origin_status: it.document_status_id,
        file: null,
      };
    });
  } else {
    return [];
  }
};
